import { TypographyOptions } from "@mui/material/styles/createTypography";

declare module "@mui/material/styles" {
  interface TypographyVariants {}
  interface TypographyVariantsOptions {}
}
declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {}
}

export const typography: TypographyOptions = {
  fontFamily: "'YekanBakh' , 'IranSans'",
  fontWeightBold: 700, // Assuming bold is 700
  fontWeightMedium: 600, // Assuming semibold is 600

  h1: {
    fontSize: 26,
    fontWeight: 700,
  },
  h2: {
    fontSize: 22,
    fontFamily: "YekanBakh",
  },
  h3: {
    fontSize: 15,
    fontFamily: "YekanBakh",
  },
  h4: {
    fontSize: 14,
    lineHeight: "24px",
  },
  h5: {
    fontSize: 12,
    lineHeight: "24px",
  },
  h6: {
    fontSize: 11,
    lineHeight: "24px",
  },
};
